import { baseQueryArgs, baseExtraOptions, rsosApi } from '../rsosApi';

const VIDEO_TO_911_BASE_ENDPOINT = 'v1/video_to_911';

export const videoTo911Api = rsosApi.injectEndpoints({
  endpoints: builder => ({
    createRoom: builder.mutation({
      query: ({ accountId, callerId, callStartTime }) => ({
        ...baseQueryArgs,
        url: `${VIDEO_TO_911_BASE_ENDPOINT}/rooms`,
        method: 'POST',
        body: {
          account_id: accountId,
          caller_id: callerId,
          call_start_time: callStartTime,
        },
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
    endRoom: builder.mutation({
      // eslint-disable-next-line no-unused-vars -- used in slice to map to room id
      query: ({ accountId, callerId, callStartTime, roomId }) => ({
        ...baseQueryArgs,
        url: `${VIDEO_TO_911_BASE_ENDPOINT}/rooms`,
        method: 'PUT',
        body: {
          account_id: accountId,
          caller_id: callerId,
          call_start_time: callStartTime,
        },
      }),
      extraOptions: {
        ...baseExtraOptions,
      },
    }),
    /**
     * Refresh the clientToken. Unauthenticated endpoint. Does not require
     * accessToken or productToken
     * @param {String} roomId - ID of the room for a video session
     * @param {String} refreshToken - Refresh token
     * @param {String} module - Video provider
     */
    refreshClientToken: builder.mutation({
      query: ({ roomId, refreshToken, module }) => ({
        ...baseQueryArgs,
        url: `${VIDEO_TO_911_BASE_ENDPOINT}/tokens/refresh`,
        method: 'POST',
        body: {
          room_id: roomId,
          refresh_token: refreshToken,
          module,
        },
        extraOptions: {
          ...baseExtraOptions,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateRoomMutation,
  useEndRoomMutation,
  useRefreshClientTokenMutation,
} = videoTo911Api;
